// extracted by mini-css-extract-plugin
export default {"content":"DocumentTable_content__L75Ka","documentsContainer":"DocumentTable_documentsContainer__uH91t","contentWrapper":"DocumentTable_contentWrapper__3o+kg"};